import { ReactNode, useCallback } from 'react';
import { Icon } from '@cbhq/cds-web/icons';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import { BaseL3ConfigEnum } from ':cloud/constants';

type BaseL3DeploymentCardProps = {
  title: BaseL3ConfigEnum;
  children?: ReactNode;
  description?: string;
  onPress: (id: BaseL3ConfigEnum) => void;
  selected: string;
  disabled?: boolean;
  tagElement?: ReactNode;
};

export function BaseL3DeploymentCard({
  children,
  description,
  selected,
  title,
  onPress,
  disabled = false,
  tagElement,
}: BaseL3DeploymentCardProps) {
  const handlePress = useCallback(() => {
    onPress(title);
  }, [title, onPress]);

  const isSelected = selected === title;

  return (
    <Pressable background="transparent" onPress={handlePress} noScaleOnPress disabled={disabled}>
      <VStack
        borderRadius="rounded"
        spacing={4}
        bordered
        borderColor={isSelected ? 'primary' : 'line'}
        gap={2}
      >
        <HStack justifyContent="space-between" alignItems="center">
          <HStack alignItems="center" gap={2}>
            <TextHeadline as="p">{title}</TextHeadline>
            {tagElement}
          </HStack>
          {isSelected && <Icon name="circleCheckmark" size="m" />}
        </HStack>
        {description && (
          <TextBody as="p" color="foregroundMuted">
            {description}
          </TextBody>
        )}
        {children}
      </VStack>
    </Pressable>
  );
}
